import { BaseService, Service } from "/@/cool";
@Service("shopSettleLog")
class ShopSettleLog extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["page"] = prefix + "page";
		this.permission["list"] = prefix + "list";
		this.permission["info"] = prefix + "info";
		this.permission["export"] = prefix + "export";
		this.permission["exportMonthExcel"] = prefix + "exportMonthExcel";
	}
	exportMonthExcel(data: any) {
		return this.request({
			url: "/exportMonthExcel",
			method: "POST",
			data
		});
	}
}
export default ShopSettleLog;
